import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './SearchBar.css';
import { MdOutlineClose } from 'react-icons/md';

const Popup = ({ onClose }) => {
  const [images, setImages] = useState([]);

  const fetchImages = async () => {
    const res = await axios.get('https://travelback-thuw.onrender.com/api/auth/get-image');
    setImages(res.data);
  };

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="image-gallery">
          {images.map(img => (
            <img className='popupImage' key={img._id} src={`https://travelback-thuw.onrender.com/${img.path}`} alt="uploaded" />
          ))}
        </div>
        <div className='clsicn' onClick={onClose}>
          <MdOutlineClose />
        </div>
      </div>
    </div>
  );
};

export default Popup;
